import { handleActions } from "redux-actions";

const initialState = {};

export default handleActions({}, initialState);
